import { Injectable, inject } from "@angular/core";
import { ICustomProperties } from "@microsoft/applicationinsights-web";
import { LgConsole } from "@logex/framework/core";

import {
    ApplicationInsightsCustomData,
    IApplicationInsightsConfiguration,
    IAuthenticationService,
    LG_APP_CONFIGURATION,
    LG_APP_SESSION,
    LG_AUTHENTICATION_SERVICE,
    LG_USER_INFO
} from "@logex/framework/lg-application";
import { ApplicationPermissions } from "@shared/app-permissions";

@Injectable({ providedIn: "root" })
export class ApplicationInsightsConfiguration implements IApplicationInsightsConfiguration {
    private _appConfiguration = inject(LG_APP_CONFIGURATION);
    private _authService = inject<IAuthenticationService>(LG_AUTHENTICATION_SERVICE);
    private _lgConsole = inject(LgConsole);
    private _session = inject(LG_APP_SESSION);
    private _userInfo = inject(LG_USER_INFO);

    constructor() {
        this._lgConsole = this._lgConsole.withSource("ApplicationInsightsConfiguration");
        this._appConfiguration.ready.then(() => {
            if (this._appConfiguration.applicationInsightsInstrumentationKey == null) {
                this._lgConsole.warn("Application Insights instrumentation key is not specified");
            }

            this.instrumentationKey =
                this._appConfiguration.applicationInsightsInstrumentationKey ?? "";
            this.correlationHeaderExcludedDomains =
                this._appConfiguration.applicationInsightsExcludeDomains ?? undefined;
            this._authService.isLoggedIn().then(loggedIn => {
                if (loggedIn) this.userId = this._authService.user?.login;
            });
        });
    }

    autoInit = true;
    instrumentationKey: string;
    userId: string | undefined;
    correlationHeaderExcludedDomains: string[] | undefined;

    doNotDoAiTracking(): boolean {
        return this.instrumentationKey == null || this.instrumentationKey === "";
    }

    customData(): ICustomProperties {
        return {
            [ApplicationInsightsCustomData.ApplicationInstance]: this._appConfiguration.instance,
            [ApplicationInsightsCustomData.ClientId]: this._session.clientId?.toString(),
            [ApplicationInsightsCustomData.ClientCode]: this._session.client?.code?.toString(),
            [ApplicationInsightsCustomData.Environment]: this._appConfiguration.environment,
            [ApplicationInsightsCustomData.ScenarioId]: this._session.scenarioId?.toString(),
            ["User ID"]: this._authService.user.login,
            ["Is Admin"]: this._userInfo.hasPermission(ApplicationPermissions.ADMIN),
            ["Is LOGEX Employee"]: this._userInfo.hasPermission(ApplicationPermissions.INTERNAL)
        };
    }
}
